<form [formGroup]="form">
    <div class="row">
        <rask-textmultiline aid="huvudkodInternnummer" class="col-1" [label]="texts.huvudkod" [value]="koppladeKunder"
            [tightLabel]="true"></rask-textmultiline>
        <rask-input aid="besokAdress" class="col-1" [label]="texts.adress" formControlName="besokAdress"
            [readonly]="true"></rask-input>
        <rask-input aid="ordernummer" class="col-1" [label]="texts.ordernummer" formControlName="ordernummer"
            [readonly]="true"></rask-input>
        <rask-input aid="sumLevrader" class="col-1" [label]="texts.sumLevrader"
            [value]="getSummaLeveransrader() | number: '1.0-0'" [readonly]="true"></rask-input>
        <rask-input aid="mattslag" class="col-1" [label]="texts.mattslag" formControlName="mattslag" [readonly]="true">
        </rask-input>
        <rask-input aid="from" class="col-1" [label]="texts.from" [value]="getPeriodFrom() | date:'yyyy-MM-dd'"
            [readonly]="true"></rask-input>
        <rask-input aid="tom" class="col-1" [label]="texts.tom" [value]="getPeriodTom() | date:'yyyy-MM-dd'"
            [readonly]="true"></rask-input>
    </div>
    <rask-toggle-panel aid="orderDetaljer" label="Detaljer" [defaultExpanded]="false">
        <ng-container>
            <rask-selector
                class="col-lg-3"
                [label]="texts.ansvarig"
                [minCharacters]="3"
                [reverseLookup]="false"
                [getSelectionFromModel]="setAvtalsAnsvarig"
                [placeholder]="texts.typeaheadText"
                [search]="avtalAnsvarigSearch"
                [viewFormatter]="avtalAnsvarigViewFormatter"
                [formatter]="avtalTypeAheadValueFormatter"
                [itemDisabled]="avtalTypeAheadDisabled"
                formControlName="avtalsansvarig"
                aid="avtalsansvarig">
            </rask-selector>
            <rask-textarea aid="beskrivning" class="col-lg-3" [label]="texts.detailBeskrv" [rows]="3"
                formControlName="beskrivning">
            </rask-textarea>
            <rask-input aid="uBy" class="col-2" [label]="texts.updatedBy" formControlName="uBy" [readonly]="true">
            </rask-input>
            <rask-input aid="iBy" [label]="texts.createdBy" formControlName="iBy" [readonly]="true"></rask-input>
        </ng-container>
    </rask-toggle-panel>
</form>
